module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "taxt-calculator"
  }, [(_vm.isCalculator) ? _c('div', [_vm._m(0, false, false), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        checkifvalid: true,
        regex: /^\d+(\.\d{1,2})?$/
      }),
      expression: "{required: true, checkifvalid: true, regex: /^\\d+(\\.\\d{1,2})?$/}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.amount),
      expression: "amount"
    }],
    class: {
      'border-red': _vm.errors.has('amount')
    },
    attrs: {
      "autocomplete": "off",
      "type": "tel",
      "name": "amount",
      "id": "amount",
      "placeholder": "Donation amount",
      "data-vv-as": "amount"
    },
    domProps: {
      "value": (_vm.amount)
    },
    on: {
      "focus": function($event) {
        _vm.setShowResult(false)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.amount = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "wwf-alert"
  }, [(_vm.errors.first('amount')) ? _c('p', [_vm._v(_vm._s(_vm.errors.first('amount')))]) : _vm._e()]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "button",
      "value": "Calculate"
    },
    on: {
      "click": _vm.calculate
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.isCalculator || _vm.isShowResult) ? _c('div', [_c('h2', [_vm._v("How much tax does that save you?")]), _vm._v(" "), _c('table', {
    staticClass: "tg"
  }, [_c('tbody', [_vm._m(1, false, false), _vm._v(" "), _vm._l((_vm.getTaxBrackeList), function(tax) {
    return _c('tr', [_c('td', {
      staticClass: "tg-yw4l"
    }, [_vm._v(_vm._s(tax.bracket))]), _vm._v(" "), _c('td', {
      staticClass: "tg-yw4l"
    }, [_vm._v(_vm._s((_vm.amount * tax.tax).toFixed(2)))])])
  })], 2)]), _vm._v(" "), (_vm.isCalculator) ? _c('a', {
    staticClass: "bttn-lrg-arrw",
    attrs: {
      "href": "#/"
    },
    on: {
      "click": _vm.donate
    }
  }, [_vm._v("Donate $" + _vm._s((_vm.amount && _vm.amount.indexOf('.00') >= 0) ? _vm.amount.slice(0, -3) : _vm.amount))]) : _vm._e()]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_vm._v("Use our tax deduction calculator to estimate your savings "), _c('span', {
    staticClass: "wwf-tooltip"
  }, [_c('p', [_vm._v("This table is based upon 2017-2018 ATO individual Income Tax rates. The above rates do not include the Medicare Levy of 2%. The exact level of your tax deductibility will vary depending on your present financial circumstances. Please seek assistance from an independent taxation professional for formal guidelines.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticClass: "tg-yw4l"
  }, [_vm._v("Income")]), _vm._v(" "), _c('th', {
    staticClass: "tg-yw4l"
  }, [_vm._v("Savings")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2cc6eae8","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=pnre6zws23l!./~/string-replace-webpack-plugin/loader.js?id=hfo8n7cvtpt!./src/components/TaxCalculator.vue
// module id = 666
// module chunks = 0